import { staticText } from 'utils/staticText';

export const productRewardBadgeTranslationConfig = {
  rewardBadgePrefix: {
    _: 'Up to',
    zh: '高達',
    'zh-hk': '高達',
    'zh-tw': '高達',
  },
  rewardBadgeSuffix: {
    _: 'in rewards',
    zh: '獎賞',
    'zh-hk': '獎賞',
    'zh-tw': '獎賞',
  },
};

export const ProductRewardBadgeTranslations = staticText(
  productRewardBadgeTranslationConfig,
);
